@if (location(); as locationValue) {
    <div>
        <div class="tab__title">{{ 'locationInfo' | translate }}</div>
        <div class="address">
            <div>{{ locationValue.company.name }}</div>
            <div>{{ locationValue.address.name }}</div>
        </div>
        <div class="address">
            @if (locationValue.address && locationValue.address.building) {
                <div>
                    <div>{{ locationValue.address.building }}</div>
                </div>
            }
            @if (locationValue.address) {
                <div>
                    @if (locationValue.address.floor) {
                        <span>{{ locationValue.address.floor }}</span>
                    }
                    @if (locationValue.address.suite && locationValue.address.floor) {
                        <span>, </span>
                    }
                    @if (locationValue.address.suite) {
                        <span>{{ locationValue.address.suite }}</span>
                    }
                </div>
            }
            <div>{{ locationValue.address.nameAdditional }}</div>
            <div>{{ locationValue.address.district }}</div>
            <div>{{ locationValue.address.street }}</div>
            <div>{{ locationValue.address.province }}</div>
            <div>{{ locationValue.address.postalCode }} {{ locationValue.address.city }}</div>
            <div>{{ countryName() }}</div>
        </div>
        <div class="address">
            @if (locationValue.address.poBox) {
                <p>{{ locationValue.address.poBox }}</p>
                @if (locationValue.zipCodeFirst) {
                    <div>{{ locationValue.address.poBoxPostalCode }} {{ locationValue.address.poBoxCity }}</div>
                } @else {
                    <div>{{ locationValue.address.poBoxCity }} {{ locationValue.address.poBoxPostalCode }}</div>
                }
            }
        </div>
        <div class="divider narrow"></div>
        <div class="detail-container">
            <div class="flat">
                <div class="label">SALID</div>
                <div>{{ locationValue.salId }}</div>
            </div>
            <div class="flat">
                <div class="label">{{ 'locationdata.locationshort' | translate }}</div>
                <div>{{ locationValue.locationCode }}</div>
            </div>
        </div>
        <div class="divider narrow"></div>
        <div class="location-info">
            <div class="time">
                <si-icon class="location-icon" icon="element-clock" />
                <span>{{ localTime() }}</span>
            </div>
            @for (mail of locationValue.emails; track mail) {
                <div>
                    <si-icon class="location-icon" icon="element-mail" />
                    <span>
                        <span>{{ mail.value }} </span>
                    </span>
                </div>
            }
            @for (tel of locationValue.phones; track tel) {
                <div>
                    <si-icon class="location-icon" icon="element-phone" />
                    <span>{{ tel.value }} </span>
                </div>
            }
            @for (fax of locationValue.faxes; track fax) {
                <div>
                    <si-icon class="location-icon" icon="element-print" />
                    <span>{{ fax.value }} </span>
                </div>
            }
            <div class="gps">
                <si-icon class="location-icon" icon="element-location" />
                <span>{{ locationValue.gps || 'N/A' }}</span>
            </div>
            @if (primaryWebsiteUrl()) {
                <div>
                    <si-icon class="location-icon" icon="element-global" />
                    <span
                        ><a [href]="$safeNavigationMigration(primaryWebsiteUrl()!.value)" target="_blank">{{
                            primaryWebsiteUrl()!.value
                        }}</a>
                    </span>
                </div>
            }
            <div class="divider narrow"></div>
            <div class="detail-container">
                <div>
                    <div class="label">{{ 'locationdata.companyshort' | translate }}</div>
                    <div>{{ locationValue.company.nameShort }}</div>
                </div>
                <div>
                    <div class="label">{{ 'locationdata.groupshare' | translate }}</div>
                    <div>{{ locationValue.company.companyShare }}</div>
                </div>
                <div>
                    <div class="label">{{ 'locationdata.are' | translate }}</div>
                    <div>{{ locationValue.company.are }}</div>
                </div>
                <div>
                    <div class="label">{{ 'locationdata.managingAre' | translate }}</div>
                    <div>{{ locationValue.company.managingAre }}</div>
                </div>
                <div>
                    <div class="label">{{ 'locationdata.businessactivity' | translate }}</div>
                    <div>{{ locationValue.company.companyType }}</div>
                </div>
                @if (locationValue.company.divisions) {
                    <div>
                        <div class="label">{{ 'locationdata.divisions' | translate }}</div>
                        <div>{{ locationValue.company.divisions }}</div>
                    </div>
                }
                @if (locationValue.company.companyTypeComment) {
                    <div class="full-width comment">
                        <div class="label">{{ 'locationdata.comment' | translate }}</div>
                        <div>{{ locationValue.company.companyTypeComment }}</div>
                    </div>
                }
                <div>
                    <div class="label">{{ 'locationdata.client' | translate }}</div>
                    <div>{{ locationValue.company.client }}</div>
                </div>
                <div class="full-width flat">
                    <div class="label">{{ 'locationdata.communenumber' | translate }}</div>
                    <div>{{ locationValue.communeNumber }}</div>
                </div>
            </div>
            <div class="divider narrow"></div>
            <div class="detail-container">
                @if (locationValue.buildings && locationValue.buildings.length) {
                    <div class="full-width">
                        <div class="label">{{ 'locationdata.buildings' | translate }}</div>
                        <table>
                            <thead>
                                <tr>
                                    <th class="col1">{{ 'locationdata.buildingnamecolumn' | translate }}</th>
                                    <th class="col2">{{ 'locationdata.buildingdescriptioncolumn' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (building of locationValue.buildings; track building) {
                                    <tr>
                                        <td class="col1">{{ building.name }}</td>
                                        <td class="col2">{{ building.description }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
                <div>
                    <div class="label">{{ 'locationdata.lastactdate' | translate }}</div>
                    <div>{{ locationValue.lastModifiedDate | date: 'dd.MM.yyyy' }}</div>
                </div>
            </div>
        </div>
    </div>
}
